import {
  creeperPixelUrl,
  deviceType,
  browserLanguage,
  newSessionId,
  rootDomain,
  tourLocation,
} from "~/utils/creeper"
import { useJoinBoxVariant } from "./useJoinBoxVariant"

// Reports tour funnel events to creeper (see utils/creeper.js), keyed on the
// stan_session cookie that the join pages and bar's join_forms also carry.
// Call it in setup; track only does anything in the browser, since tour HTML
// is cached by CloudFront and shared between visitors.
export const useTourEvents = () => {
  const inAgeRestrictedLocation = inject("inAgeRestrictedLocation")
  const userStore = useUserStore()
  const { variant } = useJoinBoxVariant()

  const track = (eventType, eventValue) => {
    if (import.meta.server || userStore.loggedIn) return

    const domain = rootDomain(window.location.hostname)
    const payload = {
      type: "event",
      site: domain,
      location: tourLocation({
        ageRestricted: inAgeRestrictedLocation,
        variant: variant.value,
      }),
      event_type: eventType,
      event_value: eventValue,
      device_type: deviceType(navigator.userAgent),
      language: browserLanguage(navigator),
      ref_url: document.referrer.split("?")[0],
      session_id: stanSession(domain),
    }

    // keepalive lets a join click's request outlive the navigation it starts.
    // no-store: the pixel has no Cache-Control, so the browser would answer a
    // repeat of the same event from its cache and creeper would never see it.
    fetch(creeperPixelUrl(payload), {
      mode: "no-cors",
      credentials: "omit",
      cache: "no-store",
      keepalive: true,
    }).catch(() => {})
  }

  return {
    trackVideoView: (release) => track("tour.video_view", release.id),
    trackJoinClick: (release) => track("tour.join_click", release.id),
  }
}

// The visitor's stan_session, minted the way bar does and set for 30 days on
// the root domain (as the join pages do) when bouncer hasn't set one already.
const stanSession = (domain) => {
  const existing = document.cookie
    .split(";")
    .map((cookie) => cookie.trim().split("="))
    .find(([name]) => name === "stan_session")?.[1]
  if (existing) return existing

  const id = newSessionId()
  const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
  document.cookie = `stan_session=${id}; expires=${expires.toUTCString()}; domain=.${domain}; path=/`
  return id
}
